// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"fcc44929","319":"a37a51d3","530":"caa98d3c","702":"caa98d3c","745":"411fd7bf"}[chunkId] + ".chunk.css";
};